var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApiFocus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "161px",
    viewBox: "0 0 241 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_API_focus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_API_focus",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_focus",
    transform: "translate(0.189209, 0.133293)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7AC82",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#D9E8F6",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M139.175734,40.7666844 C161.24844,40.4548377 166.891155,55.2791684 166.891155,72.2051922 C182.715123,76.888347 198.416104,101.350949 158.263061,114.261851 C158.263061,114.261851 85.3805795,114.261851 83.5184651,114.261851 C63.3973965,112.728743 43.8865404,82.0127983 75.0479829,74.7424996 C85.5135877,52.5900304 85.5135877,49.4743929 104.134731,49.4743929 C107.721901,49.883399 111.212404,50.9362046 114.429564,52.5900304 C121.120323,45.4152699 127.55747,40.9308291 139.175734,40.7666844 Z",
    id: "Combined-Shape-path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "API-Copy-3",
    transform: "translate(53.189209, 28.633293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud",
    transform: "translate(0.000000, 11.305694)",
    fill: "#003A5D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.75125,74.9168518 L101.75125,67.2888333 L110.064261,67.2888333 L111.214781,67.2888333 L112.185741,67.2888333 C113.040732,67.3144679 113.895743,67.2385661 114.732848,67.0627194 C122.227858,65.2405074 127.867404,59.0822292 128.146721,52.4318207 C128.459291,45.063168 123.597842,38.6388734 116.049628,36.4708402 C112.504961,35.4466773 110.656147,33.178888 110.556391,29.7206756 C110.520936,27.986817 110.316015,26.2605805 109.944553,24.566609 C107.929023,15.1101386 101.546805,9.65263534 90.4455557,7.93310458 L90.4455557,0.166920365 C90.7497274,0.204878155 91.0534549,0.246779306 91.3566616,0.292617974 C105.714894,2.44069992 114.732848,10.2682307 117.432913,22.9971126 C117.869645,25.0003701 118.121203,27.0395503 118.18441,29.0888868 C129.177535,32.2810829 136.253569,41.7845166 135.788041,52.7443899 C135.369065,62.7200026 127.268868,71.8643143 116.501856,74.4779249 C115.072715,74.7984473 113.610195,74.9458157 112.145839,74.9168518 L111.068472,74.9168518 L110.011057,74.9168518 L101.75125,74.9168518 Z M93.7707599,74.9168518 L88.2110184,74.9168518 L69.8292893,74.9168518 L69.8292893,67.2888333 L88.2642217,67.2888333 L93.7707599,67.2888333 L93.7707599,74.9168518 Z M82.4650655,0.0995541627 L82.4650655,7.84497636 C76.4981394,8.75018295 71.3399515,11.9875503 67.0959714,17.5570785 C65.6794344,19.4125424 64.0101819,20.35025 62.1480675,20.35025 C60.8703536,20.3016805 59.624793,19.9360113 58.5235948,19.2861847 C56.2433874,18.0234171 53.7662292,17.1773147 51.2081455,16.7779846 L51.2081455,9.02187595 C54.7953147,9.43779828 58.2858177,10.5084068 61.5029779,12.1901988 C67.1204782,5.16832314 74.2875396,1.03794827 82.4650655,0.0995541627 Z M43.2276553,9.20440153 L43.2276553,17.0033382 C41.0965798,17.4702037 39.0381153,18.252856 37.1225803,19.3327375 C32.8663188,21.6936325 31.0906598,25.1252433 29.3083503,30.638432 L29.221895,30.9243996 C28.8428217,32.1480747 27.8319596,35.4200757 23.4626412,35.8989051 C14.1121668,36.9297184 7.60141692,44.0656068 8.30636022,52.5249264 C8.97140107,60.5719207 16.7590294,67.3686382 25.2848531,67.3686382 L25.6639264,67.3686382 C27.2583518,67.3327373 28.8923428,67.3022012 30.5918791,67.2772429 L30.5918791,74.9029152 C28.9301724,74.9278409 27.333452,74.9589496 25.7769834,74.9966567 L25.2715523,75.0166079 C12.7089307,75.0166079 1.66925253,65.2072554 0.665040851,53.1567152 C-0.418975736,40.6738984 8.70538473,30.1263505 21.9463481,28.3772931 L21.9463481,28.3174394 C23.7552592,22.7976004 26.2491624,16.6260213 33.3650995,12.6357762 C36.4365454,10.9169988 39.776186,9.75948206 43.2276553,9.20440153 Z M38.5723693,67.2041031 C39.9023505,67.198542 41.2806609,67.1957275 42.7155738,67.1957275 C46.9851361,67.1957275 51.2347471,67.1957275 55.4311549,67.2422804 L55.8102282,67.2422804 C57.8230852,67.2552387 59.8359421,67.2655668 61.8487991,67.2732647 L61.8487991,74.9048884 C59.8026901,74.8971307 57.7565811,74.8856009 55.710472,74.870299 L55.1983906,74.870299 C51.0485357,74.870299 46.8388271,74.8237461 42.6091673,74.8237461 C41.2115345,74.8237461 39.8685051,74.8261728 38.5723693,74.831156 L38.5723693,67.2041031 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "13.2143617 93.544646 34.6153763 93.544646 34.6153763 62.1547179"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "119.268426 93.544646 97.8674116 93.544646 97.8674116 62.1547179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0718085,96.524029 L66.0718085,65.0343448",
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "25.7237801 4.21635899 47.1181443 4.21635899 47.1181443 35.6062871"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "107.650162 4.21635899 86.2491479 4.21635899 86.2491479 35.6062871"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 8.5989782,
    cy: 93.8173128,
    r: 3.94369224
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 123.88381,
    cy: 93.8173128,
    r: 3.94369224
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 65.7392881,
    cy: 100.467721,
    r: 3.94369224
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 21.1083966,
    cy: 3.94369224,
    r: 3.94369224
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 112.265546,
    cy: 3.94369224,
    r: 3.94369224
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6280113,62.3076773 C37.6280113,60.6511909 36.2851635,59.3083431 34.6286771,59.3083431 C32.9721907,59.3083431 31.6293429,60.6511909 31.6293429,62.3076773 C31.6293429,63.9641637 32.9721907,65.3070115 34.6286771,65.3070115 C36.2836465,65.3033545 37.6243536,63.9626467 37.6280113,62.3076773 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.866746,62.3076773 C100.866746,61.0945596 100.135982,60.000894 99.0152069,59.5366536 C97.8944328,59.0724138 96.6043653,59.3290245 95.7465617,60.1868274 C94.8887581,61.044631 94.6321481,62.3346986 95.0963878,63.4554726 C95.5606283,64.5762473 96.6542939,65.3070115 97.8674116,65.3070115 C99.522381,65.3033545 100.863088,63.9626467 100.866746,62.3076773 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero",
    points: "70.0554032 66.1981663 66.0718085 59.3016926 62.0948642 66.1981663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.11881,35.4533277 C44.1161206,36.6703413 44.8475172,37.7688915 45.9713791,38.2358657 C47.0952403,38.7028398 48.3897788,38.4460835 49.2503397,37.5855229 C50.1108999,36.7249623 50.3676562,35.4304236 49.9006825,34.3065623 C49.4337081,33.182701 48.3351577,32.4513039 47.1181443,32.4539935 C45.4631748,32.4576509 44.1224677,33.7983585 44.11881,35.4533277 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2498137,35.4533277 C83.2498137,37.1098143 84.5926615,38.452662 86.2491479,38.452662 C87.9056343,38.452662 89.2484821,37.1098143 89.2484821,35.4533277 C89.2484821,33.7968412 87.9056343,32.4539935 86.2491479,32.4539935 C84.5941785,32.4576509 83.2534714,33.7983585 83.2498137,35.4533277 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApiFocus);
export default __webpack_public_path__ + "static/media/Icon_API_focus.620b1c2e80310c8b04b56b81212431fc.svg";
export { ForwardRef as ReactComponent };